/** @module Sourcing/SupplierRequestCopyQuote */
define([
	"dojo/_base/declare",
	"csi/table/Copy"
], function(declare,Copy) {

	return declare(Copy, {
		/**
		 * Colors and Sizes don't apply to Copy
		 */
		onCreatePopup: function(view) {
			view.defView.removeField("Colors");
			view.defView.removeField("ProductSizes");
			this.inherited(arguments);
		}
	});
});
